import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=470a8188&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=ts"
export * from "./Btn.vue?vue&type=script&lang=ts"
import style0 from "./Btn.vue?vue&type=style&index=0&id=470a8188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a8188",
  null
  
)

export default component.exports